module.exports = __webpack_public_path__ + "assets/img/error.e2099196.svg";